import React, { FC } from 'react'

import { Feed } from 'modules/Feed/components'
import { useCurrentZoneFeed } from 'modules/Feed/serviceHooks'
import { LoadMore, NoItems } from 'components'
import { SkeletonStories } from 'modulesCommon/Skeleton/ProjectDetails'

const StoryFeedContainer: FC = () => {
  const {
    feed,
    country,
    factSourcesList,
    feedLoading,
    feedTotal,
    increaseFeedOffset
  } = useCurrentZoneFeed()

  if (feedLoading) return <SkeletonStories />

  return feed.length > 0
    ? (
      <>
        <Feed
          feed={feed as any[]}
          country={country}
          factSources={factSourcesList}
        />
        <LoadMore
          label="stories"
          onLoad={increaseFeedOffset}
          isItemsLoading={feedLoading}
          itemsTotal={feedTotal}
          itemsCount={feed.length}
        />
      </>
    ) : (
      <NoItems name="Stories" />
    )
}

export default StoryFeedContainer
